import React from 'react';
import { Info } from '../components/Info.js';
import '../App.css';
import BooksCatalog from '../components/Catalogs/BooksCatalog.js';


function BooksTPBs(){

 return(
    <>
        <Info header = 'Books-TPBs' paragraph = "Coming soon..." /> 
        
    </>

 );

} 


export default BooksTPBs;